export default __webpack_public_path__ + "static/media/uploadInvoiceWhite.d64f1f60.svg";